<template>
  <div class="action-tray" :class="{ active: show }" ref="tray">
    <div class="key-actions">
      <a
        class="key-action completion"
        :class="{ completed: action.completed }"
        @click="toggleComplete()"
        v-tooltip="{
          content: `Mark as ${action.completed ? 'in' : ''}complete`,
          delay,
        }"
      ></a>

      <a
        class="key-action priority"
        :class="action.priority"
        @click.stop="togglePrioritiesVisible()"
        v-tooltip="{ content: `Set priority`, delay }"
      ></a>
      <priority-picker
        :level="action.priority"
        :visible="priorities_visible"
        v-click-outside="setPrioritiesInvisible"
        :changePriority="changePriority"
      />

      <a
        class="key-action delete"
        @click="deleteAction()"
        v-tooltip="{ content: `Delete`, delay }"
      ></a>

      <div class="overdue" v-if="overdue && overdue_by && !action.completed">
        <img src="~@/assets/icons/alert.svg"/>
        <span
        >Overdue by {{ overdue_by }} day{{
            overdue_by === 1 ? '' : 's'
          }}</span
        >
      </div>
    </div>

    <a class="close" @click="close()"><i class="material-icons">clear</i></a>

    <textarea
      class="title flexi-textarea"
      v-model="action.title"
      v-autosize="action.title"
      placeholder="Add a title"
      rows="1"
      maxlength="256"
      @blur="updateTitle"
      ref="title"
    ></textarea>

    <dropdown
      :options="project_options"
      :value="new_action_project_id"
      :onChange="setProject"
      placeholder="Project"
      v-if="action_id === -1 && view_mode === 'tasks'"
      class="dropdown"
    />

    <h6
      class="projectName"
      v-if="project && project.name && view_mode === 'tasks'"
      @click="gotoProject(project.shortId)"
    >
      <img src="~@/assets/icons/category.svg"/>
      {{ project.name }}
      <img class="go" src="~@/assets/icons/go.svg"/>
    </h6>

    <dropdown
      :options="project_action_groups"
      :value="new_action_group_id"
      :onChange="setNewProjectGroupId"
      placeholder="Stage"
      v-if="action_id === -1 && view_mode === 'tasks' && new_action_project_id"
      class="dropdown"
    />

    <h6
      class="actionName"
      v-if="action_group_title && view_mode === 'tasks'"
      @click="gotoProject(project.shortId)"
    >
      <img src="~@/assets/icons/status.svg"/>
      {{ action_group_title }}
    </h6>

        <h4 class="label">Description</h4>
        <textarea
          class="description flexi-textarea"
          v-model="action.description"
          v-autosize="action.description"
          placeholder="Add a description"
          rows="1"
          maxlength="512"
          @blur="updateDescription"
          ref="description"
        ></textarea>
<!--    <p v-if="templates[action.title]" class="mt-3 mb-0">{{templates[action.title].notes}}</p>-->

    <div class="flex-between">
      <div class="half">
        <h4 class="label">Type</h4>
        <data-select
          type="action"
          :changeHandler="updateType"
          :filterIds="[]"
          :value="action_types[action.type]"
        />
      </div>

      <div class="half">
        <h4 class="label">Due date</h4>
        <datepicker
          :value="action.dueDate"
          mode="single"
          :onChange="updateDate"
          placeholder="SELECT"
          :icon="action.dueDate ? '' : 'plus'"
          class="datepicker"
          :id="action.id || Date.now()"
        />
      </div>
    </div>

    <h4 class="label">Assigned to</h4>
    <data-select
      type="user"
      :changeHandler="updateAssignee"
      :filterIds="[]"
      :value="action.assignee"
    />

<!--    <div class="d-flex justify-content-between align-items-center" v-if="templates[action.title]">-->
<!--      <h4 class="label d-flex justify-content-between align-items-center">-->
<!--        Resources-->
<!--&lt;!&ndash;        <a class="icon" v-tooltip="{ content: 'Upload link/document', delay: 200 }">&ndash;&gt;-->
<!--&lt;!&ndash;          <img src="~@/assets/icons/plus-grey.svg" height="16px" width="16px"/>&ndash;&gt;-->
<!--&lt;!&ndash;        </a>&ndash;&gt;-->
<!--      </h4>-->
<!--&lt;!&ndash;      <a class="icon label pr-3" v-tooltip="{ content: 'Upload link/document', delay: 200 }" style="cursor: pointer;">&ndash;&gt;-->
<!--&lt;!&ndash;        <img src="~@/assets/icons/plus-grey.svg" height="16px" width="16px"/>&ndash;&gt;-->
<!--&lt;!&ndash;      </a>&ndash;&gt;-->
<!--    </div>-->

<!--    <div class="list" v-if="templates[action.title]">-->
<!--      <div-->
<!--        class="item link"-->
<!--        v-for="(resource, i) in templates[action.title].resources"-->
<!--        :key="i"-->
<!--        @click="openLink(resource.url)"-->
<!--      >-->
<!--        <a class="icon other" :class="'other'"></a>-->
<!--        <img class="go" src="~@/assets/icons/go.svg"/>-->
<!--        <div class="stack">-->
<!--          <h6>{{ resource.title }}</h6>-->
<!--          <span class="desc">{{ resource.url }}</span>-->
<!--          <a class="click">{{resource.type === 'doc' ? 'Click to download' : 'Click to open'}}</a>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    The action expects a response-->
    <div v-if="action.responseType">
      <h4 class="label">Response</h4>
<!--      Boolean response-->
      <div v-if="action.responseType === 'boolean'">
        <a class="button" :class="{ 'outlined': action.response !== true }" @click="action.response = true; saveChanges()">Yes</a>
        <a class="button" :class="{ 'outlined': action.response !== false }" @click="action.response = false; saveChanges()">No</a>
      </div>
    </div>


    <UploadManager
      v-if="action_id !== -1"
      label="Add File"
      :files="action.linkedFiles"
      @fileAdded="action.linkedFiles.push($event); updateFiles();"
      @removeFile="action.linkedFiles.splice(action.linkedFiles.findIndex(el => el.id === $event), 1); updateFiles();"
    >
      <template v-slot:upload-button="{activateFileInput}">
        <div class="flex-between">
          <h4 class="label">Attachments</h4>
          <a
            class="icon label"
            v-tooltip="{ content: 'Upload attachment', delay: 200 }"
            style="cursor: pointer; padding-right: 12px"
            @click="activateFileInput"
          >
            <img src="~@/assets/icons/plus-grey.svg" height="16px" width="16px"/>
          </a>
        </div>
      </template>

      <template v-slot:file-item="{file, viewFile, removeFile}">
        <div class="list">
          <a
            class="item link"
          >
            <span class="icon other"></span>
            <img class="go" src="~@/assets/icons/go.svg"/>
            <div class="stack">
              <h6>{{ file.filename }}</h6>
              <span class="desc">{{ getFileDescription(file) }}</span>
              <a class="click" @click.stop.prevent="viewFile">Click to download</a>
              <img
                class="clear"
                src="~@/assets/icons/clear.svg"
                @click.stop.prevent="removeFile"
              />
            </div>
          </a>
        </div>
      </template>
    </UploadManager>

    <div class="flex-between" v-show="doc_options.length">
      <h4 class="label">
        Documents
        <span v-if="action_docs.length">({{ action_docs.length }})</span>
      </h4>

      <add-multi-dropdown
        :options="doc_options"
        :values="selected_docs"
        :onChange="toggleDocument"
        showSearch
      />
    </div>
    <div class="list" v-show="doc_options.length">
      <a
        class="item link"
        v-for="doc of action_docs"
        :key="doc.id"
        :href="doc.url"
        target="_blank"
      >
        <span class="icon" :class="doc.type.toLowerCase()"></span>
        <img class="go" src="~@/assets/icons/go.svg"/>
        <div class="stack">
          <h6>{{ doc.title }}</h6>
          <span class="desc">{{ doc.description || doc.url }}</span>
          <a class="click" :href="doc.url" target="_blank">Click to open</a>
          <img
            class="clear"
            src="~@/assets/icons/clear.svg"
            @click.stop.prevent="deleteDocument(doc.id)"
          />
        </div>
      </a>
    </div>


  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import DataSelect from '../components/DataSelect';
import Datepicker from '../components/Datepicker';
import PriorityPicker from '../components/PriorityPicker';
import AddMultiDropdown from '../components/AddMultiDropdown';
import Dropdown from '../components/Dropdown';
import UploadManager from "@/components/SelfService/UploadManager";

export default {
  name: 'ActionTray',
  data() {
    return {
      priorities_visible: false,
      delay: {show: 700, hide: 0},
      saving: false,
      // resources: [
      //   {
      //     type: 'doc',
      //     title: 'Downloadable doc',
      //     url: 'example.com'
      //   },
      //   {
      //     type: 'link',
      //     title: 'Link to system',
      //     url: 'example.com'
      //   },
      //   {
      //     type: 'doc',
      //     title: 'Downloadable doc',
      //     url: 'example.com'
      //   }
      // ]
      // templates: {
      //   ['Plan negotiation']: {
      //     notes: 'Planning should take the majority of your time during a negotiation. Use the template negotiation plan below to prepare for your negotiation.',
      //     resources: [
      //       {
      //         type: 'doc',
      //         title: 'Negotiation Plan Template',
      //         url: 'https://acada-demo-doc-bucket.s3.eu-west-2.amazonaws.com/Negotiation+Plan.xlsx'
      //       }
      //     ]
      //   },
      //   ['Issue NDAs']: {
      //     notes: 'NDA should be put in place with all parties invited to the tender. Use the link below to quickly create a mutual NDA.',
      //     resources: [
      //       {
      //         type: 'link',
      //         title: 'NDA Generator',
      //         url: 'https://docs.google.com/forms/d/e/1FAIpQLScgj_Ch7iFV3_CZUse3LMV-ghwfs7-bXIjqUh0Es77_VHEbVA/viewform?vc=0&c=0&w=1&flr=0&dods&gxids=7628'
      //       }
      //     ]
      //   },
      //   ['Identify stakeholders']: {
      //     notes: 'Identify Stakeholders. Use the email template to invite them into the process and map onto the Stakeholder Map Template below.',
      //     resources: [
      //       {
      //         type: 'doc',
      //         title: 'Stakeholder Map Template',
      //         url: 'https://acada-demo-doc-bucket.s3.eu-west-2.amazonaws.com/Stakeholder+Map.pot'
      //       },
      //       {
      //         type: 'doc',
      //         title: 'Kick-off meeting email template',
      //         url: 'https://acada-demo-doc-bucket.s3.eu-west-2.amazonaws.com/Stakeholder+kick-off+meeting.emltpl'
      //       }
      //     ]
      //   }
      // }
    };
  },
  computed: {
    action_id() {
      return this.$store.getters.current_action_id;
    },
    app_user() {
      return this.$store.getters.app_user;
    },
    view_mode() {
      return this.$store.getters.action_tray_view_mode;
    },
    action() {
      let action = this.$store.getters.current_action;

      if (!action) {
        action = {
          title: '',
          description: '',
          completed: false,
          dueDate: null,
          type: 'To-do',
          priority: null,
          assignee:
            this.app_user && this.app_user.role !== 'SuperAdmin'
              ? this.app_user
              : null,
          assigneeId:
            this.app_user && this.app_user.role !== 'SuperAdmin'
              ? this.app_user.id
              : null,
          id: -1,
          linkedDocs: [],
          linkedFiles: [],
          projectId: null,
          actionGroupId: null,
        };
      }

      return action;
    },
    action_group() {
      let group = this.$store.getters.actions.find(
        group => group.id === this.action.actionGroupId
      );

      if (!group && this.action.actionGroup) {
        group = {
          id: this.action.actionGroup.id,
          projectId: this.project_id,
        };
      } else if (!group) {
        group = {
          id: null,
          projectId: null,
        };
      }

      return group;
    },
    new_action_group_id() {
      return this.$store.getters.new_action_group_id;
    },
    new_action_project_id() {
      return this.$store.getters.new_action_project_id;
    },
    action_group_title() {
      const id = this.action_group
        ? this.action_group.id
        : this.new_action_group_id;
      const group = this.project_actions.find(a => a.id === id);
      return group && id ? group.title : null;
    },
    projects() {
      return this.$store.getters.projects;
    },
    project() {
      if (!this.all_projects) return null;
      const key = Object.keys(this.all_projects).find(
        p => this.all_projects[p].id === this.action.projectId
      );
      if (
        key &&
        this.all_projects &&
        this.all_projects[key] &&
        !this.all_projects[key].hasOwnProperty('projectDocuments')
      ) {
        // get project detail
        this.$store.dispatch('getProjectDetail', this.project_id).then(() => {
          return this.all_projects[key];
        });
      } else {
        return this.all_projects[key];
      }
      return null;
    },
    project_id() {
      if (!this.project) return this.new_action_project_id;
      return this.project.id;
    },
    project_docs() {
      if (!this.project || !this.project.projectDocuments) return [];
      return this.project.projectDocuments;
    },
    project_actions() {
      return this.$store.getters.actions;
    },
    action_types() {
      return this.$store.getters.action_types;
    },
    show() {
      return this.$store.getters.show_action_tray;
    },
    today() {
      return moment().startOf('d');
    },
    overdue() {
      if (!this.action.dueDate) return false;
      const due_day = moment(this.action.dueDate).startOf('d');
      return due_day.isBefore(this.today);
    },
    overdue_by() {
      if (!this.overdue) {
        return '';
      }

      const due_day = moment(this.action.dueDate).startOf('d');
      return this.today.diff(due_day, 'd');
    },
    dueDate() {
      return this.action.dueDate;
    },
    action_docs() {
      if (
        !this.project_docs.length ||
        !this.action.linkedDocs ||
        !this.action.linkedDocs.length
      )
        return [];
      return this.project_docs.filter(doc =>
        this.action.linkedDocs.find(linked => linked.id === doc.id)
      );
    },
    doc_options() {
      return this.project_docs.map(doc => {
        return {text: doc.title, value: doc.id};
      });
    },
    selected_docs() {
      return this.action_docs.map(doc => doc.id);
    },
    project_action_groups() {
      if (!this.project_actions) return [];
      return this.project_actions.map(group => {
        return {text: group.title, value: group.id};
      });
    },
    all_projects() {
      return this.$store.getters.all_projects;
    },
    project_options() {
      return Object.keys(this.all_projects)
        .filter(key => key !== this.project_id)
        .map(key => {
          return {
            text: this.all_projects[key].name,
            value: this.all_projects[key].id,
            shortId: this.all_projects[key].shortId,
          };
        });
    },
  },
  methods: {
    clickOutside() {
      if (this.action) {
        this.close();
      }
    },
    close() {
      if (this.action) {
        this.$store.dispatch('setActionTrayVisibility', false);
      }
    },
    updateTitle() {
      if (this.action_id === -1 && !this.action.title) {
        return;
      }
      this.saveChanges();
    },
    updateDescription() {
      if (this.action_id === -1 && !this.action.description) {
        return;
      }
      this.saveChanges();
    },
    updateAssignee(user, mode) {
      if (mode === 'add') {
        Vue.set(this.action, 'assignee', user);
      } else if (mode === 'remove') {
        Vue.set(this.action, 'assignee', null);
      }

      this.saveChanges();
    },
    updateDate(date) {
      if (date) {
        const new_date = moment(date);
        const old_date = this.action.dueDate
          ? moment(this.action.dueDate)
          : moment('1970-01-01');

        if (
          new_date.isValid() &&
          old_date.isValid() &&
          !new_date.isSame(old_date, 'd')
        ) {
          Vue.set(this.action, 'dueDate', new_date.toISOString());
          this.saveChanges();
        }
      } else {
        Vue.set(this.action, 'dueDate', null);
        this.saveChanges();
      }
    },
    updateType(type, mode) {
      if (mode === 'add') {
        Vue.set(this.action, 'type', type.value);
      } else if (mode === 'remove') {
        Vue.set(this.action, 'type', null);
      }

      this.saveChanges();
    },
    toggleComplete() {
      Vue.set(this.action, 'completed', !this.action.completed);
      this.saveChanges();
    },
    updateFiles() {
      if (this.action_id === -1 && !(this.action.linkedFiles && this.action.linkedFiles.length > 0)) {
        return;
      }
      this.saveChanges();
    },
    async saveChanges() {
      if (
        !this.action.title ||
        !this.project_id ||
        (!this.action_group.id && !this.new_action_group_id)
      )
        return;

      // if the action has never been saved, and we're already saving, wait a second and then try again
      if (this.action_id === -1 && this.saving) {
        setTimeout(() => {
          this.saveChanges();
        }, 1000);
        return;
      }

      const action = JSON.parse(JSON.stringify(this.action));
      action.projectId = this.project_id;
      delete action.project;
      delete action.actionGroup;

      try {
        if (this.action_id === -1) {
          this.saving = true;

          const params = {
            action_group_id: this.action_group.id || this.new_action_group_id,
            actions: [action],
            project_id: this.project_id,
            refresh_after: this.view_mode === 'project',
          };

          const saved_project = await this.$store.dispatch(
            'createActions',
            params
          );
          if (saved_project && saved_project.length) {
            this.$store.dispatch('setCurrentActionId', saved_project[0].id);
            // debugger
            this.$store.dispatch('setCurrentAction', saved_project[0]);
          }
          this.saving = false;
        } else {
          this.saving = true;
          await this.$store.dispatch('updateAction', {
            action,
            project_id: this.project_id,
            refresh_after: this.view_mode === 'project',
          });
          this.saving = false;
        }
      } catch (e) {
        console.error(e);
        this.saving = false;
      }
    },
    togglePrioritiesVisible() {
      this.priorities_visible = !this.priorities_visible;
    },
    setPrioritiesInvisible() {
      this.priorities_visible = false;
    },
    changePriority(priority) {
      Vue.set(this.action, 'priority', priority);
      this.setPrioritiesInvisible();
      this.saveChanges();
    },
    toggleDocument(id) {
      if (this.action.linkedDocs.find(linked => linked.id === id)) {
        this.deleteDocument(id);
      } else {
        this.addDocument(id);
      }
    },
    addDocument(id) {
      const doc = this.project_docs.find(d => d.id === id);
      this.action.linkedDocs.push(doc);
      this.saveChanges();
    },
    deleteDocument(id) {
      this.action.linkedDocs = this.action.linkedDocs.filter(
        linked => linked.id !== id
      );
      this.saveChanges();
    },
    async deleteAction() {
      try {
        const options = {
          html: false,
          okText: 'Delete',
          cancelText: 'Cancel',
          customClass: 'acada-confirm',
          animation: 'fade',
        };

        const message = {
          title: 'Delete action',
          body: 'Are you sure you want to delete this action?',
        };

        await this.$dialog.confirm(message, options);
        this.$store.dispatch('deleteActions', {
          actions: [this.action_id],
          project_id: this.project_id,
          refresh_after: this.view_mode === 'project',
        });
        this.close();
      } catch (e) {
        // they clicked cancel, so don't delete the action
      }
    },
    async get_project_options() {
      if (!Object.keys(this.all_projects).length) {
        await this.$store.dispatch('getAllProjects');
      }
    },
    setProject(val) {
      this.$store.dispatch('setNewActionProjectId', val);
      this.$store.dispatch('getProjectActions', {
        id: val,
        request_time: moment(),
      });
      this.saveChanges();
    },
    setNewProjectGroupId(val) {
      this.$store.dispatch('setNewActionGroupId', val);
      this.action_group.id = val;
      this.saveChanges();
    },
    async gotoProject(id) {
      if (id) {
        this.$router.push({name: 'ProjectDetail', params: {id}});
        document.querySelector('#main-view').scrollTo(0, 0);
      }
    },
    openLink(url) {
      url = url.match(/^http[s]?:\/\//) ? url : 'https://' + url;
      window.open(url, '_blank').focus();
    },
    getFileDescription(file) {
      if(file.status) {
        if (file.status === 'failed') return 'Failed to upload';
        if (file.status === 'uploading') {
          return file.progress > 1 ? `Uploading ${file.progress}%` : 'Uploading...'
        }
      } else if (file.id) {
        return file.size > 0 ? this.formatBytes(file.size) : '';
      }
      return '';
    },
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes';

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
  },
  components: {
    UploadManager,
    'data-select': DataSelect,
    'priority-picker': PriorityPicker,
    'add-multi-dropdown': AddMultiDropdown,
    datepicker: Datepicker,
    dropdown: Dropdown,
  },
  watch: {
    action_id(val) {
      this.$refs.tray.scrollTo(0, 0);

      if (!this.project_options.length) {
        this.get_project_options();
      }

      if (this.project_id) {
        this.$store.dispatch('getProjectActions', {
          id: this.project_id,
          request_time: moment(),
        });
      }
    },
    action() {
      if (!this.project_options.length) {
        this.get_project_options();
      }
    },
    new_action_project_id(val) {
      if (val) {
        this.$store.dispatch('getProjectActions', {
          id: val,
          request_time: moment(),
        });
      }
    },
  },
};
</script>
<!--TODO - Add Scoped-->
<style lang="scss">
@import '../styles/colors.scss';

.action-tray {
  position: fixed;
  top: 80px;
  right: -380px;
  transition: right 0.6s;
  border-left: 1px solid $border-color;
  padding: 37px 25px;

  height: calc(100% - 80px);
  width: 375px;
  background: #f9fafc;
  pointer-events: none;

  overflow-y: auto;

  &.active {
    right: 0;
    pointer-events: auto;
  }

  .close {
    position: absolute;
    top: 40px;
    right: 22px;
    cursor: pointer;
    user-select: none;
    height: 24px;
  }

  .flexi-textarea.title {
    font-size: 24px;
    color: #26292f;
    font-weight: 500;
    margin: 0;
    width: 100%;
    line-height: normal;
  }

  .label {
    color: #26292f;
    font-size: 16px;
    font-weight: 500;
    margin-top: 25px;
    margin-bottom: 15px;

    span {
      color: #c6d0db;
    }

    + .action-btn {
      margin-top: 35px;
      margin-bottom: 15px;
      cursor: pointer;
    }
  }

  .overdue {
    background: $red;
    font-weight: 500;
    font-size: 13px;
    padding: 2px 8px 3px;
    border-radius: 4px;
    display: inline-block;
    user-select: none;

    span {
      color: white;
    }

    img {
      margin-right: 3px;
      position: relative;
      top: -2px;
    }
  }

  .key-actions {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 30px;
    position: relative;

    .key-action {
      border-radius: 15px;
      width: 30px;
      height: 30px;
      margin-right: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background-repeat: no-repeat;
      background-position: top left;

      img {
        width: 12px;
        height: auto;
      }

      &.priority {
        background-image: url(~@/assets/icons/priorities.svg);
        background-size: 120px 30px;

        &.Low {
          background-position: top left -30px;
        }

        &.Medium {
          background-position: top left -60px;
        }

        &.High {
          background-position: top left -90px;
        }
      }

      &.completion {
        background-image: url(~@/assets/icons/completion.svg);
        background-size: 60px 30px;

        &.completed {
          background-position: top left -30px;
        }
      }

      &.delete {
        background-image: url(~@/assets/icons/trash.svg);
        background-size: 30px 30px;
      }
    }
  }

  .flexi-textarea {
    border-color: transparent;
    outline: none;
    width: 100%;
    background: transparent;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    resize: none;
    transition: border 0.2s;

    &:hover {
      border-bottom-color: #dbdee5;
      resize: auto;
    }

    &:active,
    &:focus {
      border-bottom-color: #b6bac4;
      resize: auto;
    }
  }

  .datepicker .datepicker-input,
  .data-select {
    margin-bottom: 0;
  }

  .datepicker,
  .datepicker .datepicker-input {
    max-width: 100%;

    > .popover-origin > .popover-content-wrapper > .popover-content {
      left: -110px;

      &:after {
        left: 130px !important;
      }
    }
  }

  .half {
    width: 50%;

    .data-select {
      width: 100%;

      .add {
        width: calc(100% - 10px);
        margin-right: 10px;
      }
    }
  }
}

.datepicker {
  margin-top: -15px;
}

.dropdown {
  margin-top: 10px;
}

.projectName,
.actionName {
  cursor: pointer;
  font-weight: 400;
  padding-left: 3px;
  font-size: 16px;
  margin-top: 20px;
  color: #acb6c1;
  position: relative;
  width: 100%;

  img {
    position: relative;
    top: -0px;
    margin-right: 5px;

    &.go {
      opacity: 0;
      transition: opacity 0.3;
    }
  }

  &:hover {
    img.go {
      opacity: 1;
    }
  }
}

.actionName {
  font-size: 14px;
  margin-top: 15px;
}
</style>
